import React from "react";
import {
  MDBCard,
  MDBCardTitle,
  MDBCardBody,
  MDBCardText,
} from "mdb-react-ui-kit";
import { motion } from "framer-motion";
import "../styles/pelvicCareProgram.css";

const PelvicSenseTestimonialCard = ({ text, name, image, altText, width }) => {
  return (
    <motion.div
      className="border-radius-8 h-100 bg-blue"
      whileHover={{
        scale: 1.1,
      }}
      animate="visible"
      initial="hidden"
    >
      <MDBCard className="review-card border-0 bg-blue">
        <MDBCardBody classNam="position-relative">
          <MDBCardTitle className="mb-3">
            <div>
              <img className="img-fluid" src={image} alt={altText} />
            </div>
          </MDBCardTitle>
          <MDBCardText className="text-dm fs-testimonial-card-text-20-16-14 pb-3">
            <p className="fs-18-16">{text}</p>
          </MDBCardText>
          <span className="text-al text-black position-absolute bottom-0 start-0 ms-name-text-blue-cards mb-2 fs-24">
            - {name}
          </span>
        </MDBCardBody>
      </MDBCard>
    </motion.div>
  );
};

export default PelvicSenseTestimonialCard;
